export const Reports = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_3622_1478)">
        <path
          d="M21.3674 9.22948C21.365 7.08577 20.9039 5.9038 19.7332 4.53681C18.3388 2.90861 16.983 2.62768 14.8651 2.29572L14.8652 9.22949L21.3674 9.22948Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 3V12.0394H20.7797C20.4266 16.8432 17.8196 19.0451 16.4487 19.8243C15.0779 20.6035 13.5264 21.0089 11.9496 20.9999C10.3728 20.9908 8.82602 20.5676 7.46422 19.7727C6.10242 18.9778 4.97336 17.839 4.19012 16.4705C3.40687 15.1019 2.99693 13.5516 3.00135 11.9748C3.00576 10.398 3.42438 8.84999 4.21527 7.48585C5.00617 6.12171 6.14158 4.9893 7.50781 4.20202C8.87404 3.41475 10.4231 3.00024 12 3Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3622_1478">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
